export { placeholderPlugin } from './src/index';
